import { formatDateTime } from "@/lib/format";
import { CircleDot } from "lucide-react";

export function Timeline({ audit }) {
  if (!audit || audit.length === 0) {
    return <p className="text-sm text-patria-muted">No activity yet.</p>;
  }
  return (
    <ol className="relative border-l-2 border-patria-green/20 ml-2 space-y-5" data-testid="case-timeline">
      {audit.map((a, i) => (
        <li key={i} className="ml-5" data-testid={`timeline-item-${i}`}>
          <span className="absolute -left-[9px] flex h-4 w-4 items-center justify-center">
            <CircleDot className="h-4 w-4 text-patria-green bg-patria-surface rounded-full" />
          </span>
          <div className="flex flex-wrap items-baseline justify-between gap-x-3">
            <p className="text-sm font-medium text-patria-ink">{a.action}</p>
            <time className="text-xs text-patria-muted">{formatDateTime(a.timestamp)}</time>
          </div>
          {a.detail && <p className="text-sm text-patria-muted mt-0.5">{a.detail}</p>}
          <p className="text-xs text-patria-muted mt-0.5">{a.actor_name} · {a.actor_role?.replace("_", " ")}</p>
        </li>
      ))}
    </ol>
  );
}
